var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('button',{staticClass:"button button-secondary mt-4 ml-auto mr-3",class:{ 'button-disabled': _vm.disabled, 'button-secondary': !_vm.disabled },on:{"click":_vm.handleClick}},[_vm._v(" Responder ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }